import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CurrencyPipe, DatePipe, NgClass } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import {
  TableColumn,
  INVENTORY_TABLE_COLUMNS,
} from '@app/utils/constants/inventory-table.constant';
import { IconName } from '@app/utils/enums/icon-enum';
import { IconComponent } from '../../../../components/shared/icon/icon.component';
import { InventoryColumnKey } from '@app/utils/enums/inventory-table-columns.enum';
import { InventoryItem } from '@app/utils/interfaces/inventory-item.interface';

@Component({
  selector: 'app-inventory-item',
  standalone: true,
  imports: [
    NgClass,
    DatePipe,
    MatIconModule,
    TranslateModule,
    MatMenuModule,
    MatButtonModule,
    CurrencyPipe,
    IconComponent,
  ],
  templateUrl: './inventory-item.component.html',
  styleUrl: './inventory-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InventoryItemComponent {
  public readonly inventoryItem = input.required<InventoryItem>();
  public readonly openModal = output<InventoryItem>();
  public readonly openEditModal = output<InventoryItem>();

  public readonly iconName = IconName;
  public readonly columns: TableColumn[] = INVENTORY_TABLE_COLUMNS;
  public readonly inventoryColumnKey = InventoryColumnKey;

  public onOpenModal(): void {
    this.openModal.emit(this.inventoryItem());
  }

  public onOpenEditModal(): void {
    this.openEditModal.emit(this.inventoryItem());
  }

  public getColumnValue(item: InventoryItem, key: InventoryColumnKey): string | number {
    switch (key) {
      case InventoryColumnKey.BRAND_NAME:
        return item.brand?.name ?? item.brandName ?? '-';
      case InventoryColumnKey.PRODUCT_LOCATION:
        return item.productLocation ?? '-';
      case InventoryColumnKey.PRODUCT_CATEGORY:
        return item.mainCategory?.name ?? item.productCategory ?? '-';
      case InventoryColumnKey.AVAILABLE_AMOUNT:
        return item.availableAmount;
      case InventoryColumnKey.RESERVED_AMOUNT:
        return item.reservedAmount;
      case InventoryColumnKey.ON_HAND_AMOUNT:
        return item.onHandAmount;
      case InventoryColumnKey.PRICE:
        return item.price;
      default:
        return '-';
    }
  }
}
